import { Tag } from 'antd';
import React, { FunctionComponent, useCallback } from 'react';
import { Order, OrderStatus } from '../services/orders-service/types';
import StringUtils from '../utils';

/**
 * OrderTag props
 */
interface Props {
  order: Order;
}

/**
 * OrderTag Component
 */
const OrderTag: FunctionComponent<Props> = ({ order }) => {
  const statusColor = useCallback((status: OrderStatus) => {
    if (status === OrderStatus.ORDER_REJECTED) return 'red';
    if (status === OrderStatus.KIT_SHIPPED) return 'purple';
    if (status === OrderStatus.SPECIMEN_RECEIVED) return 'purple';
    if (status === OrderStatus.RECOLLECTION_REQUIRED) return 'purple';
    if (status === OrderStatus.COMPLETED) return 'green';
    if (status === OrderStatus.RELEASE_APPROVED) return 'green';
    if (status === OrderStatus.RELEASE_REJECTED) return 'red';
    return 'blue';
  }, []);

  return (
    <Tag color={statusColor(order.status)}>
      {StringUtils.capitalize((order.status || 'New').toLowerCase())}
    </Tag>
  );
};

export default OrderTag;
